<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
    [options]="{ forceVisible: true }">
    <form [formGroup]="propertyPortalsForm" *ngIf="dataToFormInitPortals.portals?.length>0 && isView" #formElementRef>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <!-- <div class="col-lg-3" *ngFor="let portal of dataToFormInitPortals?.portals; index as i">
                        <div class="form-check form-check-inline form-switch form-switch-md form-switch-primary mb-3">
                            <input class="form-check-input" type="checkbox" role="switch"
                                id="SwitchPortal{{ portal.id }}" formControlName="portal{{ portal.id }}" />
                            <label class="form-check-label" for="SwitchPortal{{ portal.id }}">{{
                                portal.name }}</label>
                        </div>
                    </div> -->
                    <!--end col-->
                    <div class="table-responsive">
                        <table class="table align-middle mb-0">
                            <thead class="text-muted">
                                <tr>
                                    <th style="width: 35%;">{{'t-name' | translate}}</th>
                                    <th style="width: 30%;">{{'t-last-send-date'|translate}}</th>
                                    <!-- <th style="width: 20%;" class="d-none">{{'t-send-date'|translate}}</th> -->
                                    <th style="width: 30%;">{{'t-sending-status'|translate}}</th>
                                    <th style="width: 5%;">{{'t-status' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let portal of dataToFormInitPortals?.portals; index as i">
                                    <th [ngClass]="{
                                                    'opacity-100':propertyPortalsForm.get('portal'+portal.id)?.value,
                                                    'opacity-50':!propertyPortalsForm.get('portal'+portal.id)?.value
                                                }">
                                        <div class="d-flex align-items-center">


                                            <div class="avatar-xxs">
                                                <span class="avatar-title rounded-circle">
                                                    {{ portal.name.charAt(0) }}
                                                </span>
                                            </div>
                                            <div class="flex-grow-1 ms-2">
                                                {{portal.name}}
                                            </div>
                                        </div>
                                    </th>
                                    <td [ngClass]="{
                                        'opacity-100':propertyPortalsForm.get('portal'+portal.id)?.value,
                                        'opacity-50':!propertyPortalsForm.get('portal'+portal.id)?.value
                                        }">
                                        <ng-container *ngIf="propertyPortalsForm.get('portal'+portal.id)?.value">
                                            <ng-container *ngIf="getLastUpdatedDate(portal.id)">
                                                {{getLastUpdatedDate(portal.id) | amLocale:langValue | amDateFormat:
                                                'L'}}
                                            </ng-container>
                                            <ng-container *ngIf="!getLastUpdatedDate(portal.id)">
                                                ---
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="!propertyPortalsForm.get('portal'+portal.id)?.value">
                                            ---
                                        </ng-container>

                                    </td>
                                    <td class="d-none" [ngClass]="{
                                                    'opacity-100':propertyPortalsForm.get('portal'+portal.id)?.value,
                                                    'opacity-50':!propertyPortalsForm.get('portal'+portal.id)?.value
                                                }">
                                        <ng-container *ngIf="propertyPortalsForm.get('portal'+portal.id)?.value">
                                            <ng-container
                                                *ngIf="getDateUpdate(portal.id) && !getUpdatingStatus(portal.id)">
                                                {{getDateUpdate(portal.id) | amLocale:langValue | amDateFormat: 'L'}}
                                            </ng-container>
                                            <ng-container
                                                *ngIf="!getDateUpdate(portal.id) || getUpdatingStatus(portal.id)">
                                                ---
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="!propertyPortalsForm.get('portal'+portal.id)?.value">
                                            ---
                                        </ng-container>

                                    </td>
                                    <td [ngClass]="{
                                                    'opacity-100':propertyPortalsForm.get('portal'+portal.id)?.value,
                                                    'opacity-50':!propertyPortalsForm.get('portal'+portal.id)?.value
                                                }">

                                        <ng-container
                                            *ngIf="propertyPortalsForm.get('portal'+portal.id)?.value && propertyId">
                                            <span class="text-danger"
                                                *ngIf="checkLogs(portal.id)">

                                                <a href="javascript:void(0);" class="link-danger"
                                                    (click)="openModal(portal.id)">
                                                    <i class="ri-close-circle-line fs-17 align-middle"></i>
                                                    {{'t-not-finished'|translate}} ({{getCountPortalLogs(portal.id)}})
                                                    <i class="ri-arrow-right-s-line align-middle lh-1"></i>
                                                </a>

                                            </span>
                                            <span class="text-success"
                                                *ngIf="!getUpdatingStatus(portal.id) && !checkLogs(portal.id) && getDateUpdate(portal.id)">

                                                <i class="ri-checkbox-circle-line fs-17 align-middle"></i>
                                                {{'t-finished'|translate}}
                                            </span>
                                            <span class="text-warning"
                                                *ngIf="(!getDateUpdate(portal.id) || getUpdatingStatus(portal.id)) && !checkLogs(portal.id)">
                                                <i class="ri-time-line fs-17 align-middle"></i>
                                                {{'t-processing'|translate}}
                                            </span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="!propertyPortalsForm.get('portal'+portal.id)?.value || !propertyId">
                                            ---
                                        </ng-container>

                                    </td>
                                    <td>
                                        <div class="form-check form-check-inline form-switch form-switch-primary mb-3">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                id="SwitchPortal{{ portal.id }}"
                                                formControlName="portal{{ portal.id }}" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--end table-->
                </div>
            </div>
        </div>
    </form>
</ngx-simplebar>

<ng-template #content1 role="document" let-modal>
    <div class="modal-header bg-light  p-3">
        <h5 class="modal-title">{{logsTitleFilters}} {{'t-sending-status' | translate}}</h5>
        <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close" id="close-modal"
            (click)="modal.dismiss('Cross click')">
        </button>
    </div>
    <div class="modal-body">
        <div class="d-flex" *ngFor="let item of logsFilters;">
            <div class="flex-shrink-0">
                <i class="ri-close-circle-fill text-danger"></i>
            </div>
            <div class="flex-grow-1 ms-2 text-muted">
                {{item.message|translate}}
            </div>
        </div>
    </div>
    <div class="modal-footer bg-body pt-2 pb-2">
        <div class="hstack gap-2 justify-content-end">
            <button type="button" class="btn btn-soft-dark waves-effect waves-light"
                (click)="modal.close('Close click')">{{'t-close' | translate}}</button>
        </div>
    </div>
</ng-template>